/**
 * Utility functions for handling form group validation (checkboxes and radio buttons)
 */

/**
 * Get the values of all checked checkboxes in a checkbox group
 * @param {HTMLElement} field - The checkbox group container or a checkbox within the group
 * @returns {string[]} Array of selected values
 */
export function getCheckboxGroupValues(field) {
    const container = field.getAttribute("data-field-type") === "checkboxGroup" ? field : field.closest('[data-field-type="checkboxGroup"]');

    if (!container) {
        // eslint-disable-next-line no-console
        console.warn("No checkbox group container found for field:", field);
        return [];
    }

    const checkboxes = container.querySelectorAll('input[type="checkbox"]:checked');
    return Array.from(checkboxes).map(cb => cb.value);
}

/**
 * Get the value of the selected radio button in a radio group
 * @param {HTMLElement} field - The radio group container or a radio button within the group
 * @returns {string|null} Selected value or null if nothing is selected
 */
export function getRadioGroupValue(field) {
    const container = field.getAttribute("data-field-type") === "radioGroup" ? field : field.closest('[data-field-type="radioGroup"]');

    if (!container) {
        // eslint-disable-next-line no-console
        console.warn("No radio group container found for field:", field);
        return "";
    }

    const selectedRadio = container.querySelector('input[type="radio"]:checked');

    return selectedRadio ? selectedRadio.value : "";
}

/**
 * Check if a radio group has a selected value
 * @param {HTMLElement} field - The radio group container or a radio button within the group
 * @returns {boolean} True if any radio button is selected
 */
export function hasRadioGroupValue(field) {
    return getRadioGroupValue(field) !== "";
}
